import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=14d3e10b"
var script = {}
import style0 from "./ModalComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports